module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bPAfI"))).then(() => parcelRequire('37nVf'));